const awardsSwipper = {
  props: {
    dynamicClass: ".c-awards-swipper.dynamicLoading",
    compSelector: ".c-awards-swipper",
    cssSelector: "JS-awards-swipper",
    cssSelectorSwiper: ".swiper-wrapper[data-items-load]",
    nameAttr: "data-items-load",
    config: {
      slidesPerView: 1,
      spaceBetween: 0,
      loopedSlides: 1,
      loop: false,
      grabCursor: true,
      wrapperClass: "swiper-wrapper",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
    tabsTitlesSelector: ".Js-awards-tabtitle",
    tabsContainerSelector: ".JS-awards-container",
    active: "active",
    hidden: "hidden",
  },
  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-awardsSwiper.css", this.props.dynamicClass);

    bcl.u.swiper.init(document, this.props);
    const components = document.querySelectorAll(this.props.compSelector);
    components?.forEach((cmp) => {
      this.initTabs(cmp);
    });
  },
  initTabs: function (cmp) {
    const tabs = cmp.querySelectorAll(this.props.tabsTitlesSelector);
    const tabsContainer = cmp.querySelectorAll(this.props.tabsContainerSelector);
    if (tabs && tabsContainer && tabs.length > 1) {
      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          if (!tab.classList.contains(this.props.active)) {
            this.showContainer(tabs, tabsContainer, index);
          }
        });
      });
    }
  },
  showContainer: function (tabs, tabsContainer, tabIndex) {
    tabs.forEach((el, index) => {
      el.classList.toggle(this.props.active, index == tabIndex);
    });
    tabsContainer.forEach((el, index) => {
      el.classList.toggle(this.props.hidden, index != tabIndex);
    });
  },
};

export default awardsSwipper;
